<template>
    <div class="oo">
        <digital-server :image_url="image_url" :icon_url="icon_url" 
                        :small_title="{en: context['看板'].left_top, ch: context['看板'].left_bottom}" 
                        :big_title="{title: context['看板'].title, content: context['看板'].content}"
        ></digital-server>
        <div class="pain">
            <div class="pain_container">
                <Title :title="context['行业痛点'].title" :content="context['行业痛点'].content"></Title>
                <div class="pain_item">
                    <div class="item_container" v-for="(item, index) in context['行业痛点'].item" :key="index">
                        <img :src="item.img">
                        <p style="color: #fff; margin-top: 1.5rem;">{{ item.title }}</p>
                        <div class="line"></div>
                        <p style="color: rgb(193, 193, 193); padding: 0 10%; line-height: 2; font-size: 0.8rem;">{{ item.content }}</p>
                    </div>
                </div>
            </div>
        </div>
         <!-- 成功案例 -->
         <div class="resolve">
            <div class="resolve_container">
                <Title :title="context['解决方法'].title" :content="context['解决方法'].content"></Title>
                <resolve-project :projects="context['解决方法'].item"></resolve-project>
            </div>
        </div>
        <div class="video">
            <div class="video_container">
                <Title :title="context['成功案例'].title" :content="context['成功案例'].content"></Title>
                <SuccessVideo :cover="cover" :url="url" :company="context['成功案例'].company" :company_content="context['成功案例'].company_content"></SuccessVideo>
            </div>
        </div>
    </div>
</template>

<script>
import { getText, getVideos } from "../../util"
import { fromDictToArray } from "../../util/tool"
import digitalServer from "../../components/digitalServer"
import resolveProject from "../../components/resolveProjects"
import Title from '../../components/title'
import DigitalResolve from '../../components/digitalResolve'
import SuccessVideo from '../../components/successVideo'
import { titleEnergy,digitalEnergy,successfulProjects,digitalFactory } from '../../util/constant'
export default {
    data() {
        return {
            image_url: require('../../assets/image/5.1.png'),
            icon_url: require('../../assets/image/资源 326.png'),
            small_title:{
                en:'DigitalTwins + factory',
                ch:'数字孪生 + 园区'
            },
            big_title: {
                title:'园区孪生解决方案',
                content:'以三维场景为依托、生产数据为核心、生产业务为纽带，实现工厂园区、车间、流水线、设备的逐级可视，并整合各个流程节点之间的数据及信息对生产过程进行综合监管及全局分析，形成智慧工厂管理的新模式'
            },
            titleEnergy,
            digitalFactory,
            painItemArray:[
                {
                    title:'信息数据分散',
                    img: require('../../assets/image/资源 66.png'),
                    content:'涉海相关的企事业单位针对海洋领域研究相对专业，海洋相关的数据分布在各个事业单位中，数据源比较分散'
                },
                {
                    title:'信息数据分散',
                    img: require('../../assets/image/资源 65.png'),
                    content:'涉海相关的企事业单位针对海洋领域研究相对专业，海洋相关的数据分布在各个事业单位中，数据源比较分散'
                },
                {
                    title:'信息数据分散',
                    img: require('../../assets/image/资源 64.png'),
                    content:'涉海相关的企事业单位针对海洋领域研究相对专业，海洋相关的数据分布在各个事业单位中，数据源比较分散'
                },
                {
                    title:'信息数据分散',
                    img: require('../../assets/image/资源 63 (2).png'),
                    content:'涉海相关的企事业单位针对海洋领域研究相对专业，海洋相关的数据分布在各个事业单位中，数据源比较分散'
                }
            ],
            context: {
                '看板':{},
                '行业痛点':{},
                '解决方法':{},
                '成功案例':{}
            },
            cover:'',
            url:'',
        }
    },
    components: {
        digitalServer,
        Title,
        DigitalResolve,
        resolveProject,
        SuccessVideo
    },
    mounted() {
        let page = '数字孪生+园区'
        getText(page).then(res=>{
            if(res.code === 200) {
                this.context['看板'] = res.data[0]
                this.context['行业痛点'] = res.data[1]
                this.context['行业痛点'].item = fromDictToArray(res.data[1])
                this.context['行业痛点'].item.forEach((item, index) => {
                    if(index === 3){
                        item.img = require('../../assets/image/园区-安全管理.png')
                    }else if(index === 2){
                        item.img = require('../../assets/image/园区-设备维护成本高.png')
                    }else if(index === 1){
                        item.img = require('../../assets/image/园区-效率低.png')
                    }else if(index === 0){
                        item.img = require('../../assets/image/园区-数据孤岛与信息共享不足.png')
                    }
                })
                this.context['解决方法'] = res.data[2]
                this.context['解决方法'].item = fromDictToArray(res.data[2])
                this.context['解决方法'].item.forEach((item, index) => {
                    item.image = require(`../../assets/image/5.3-${index+1}.png`)
                })
                this.context['成功案例'] = res.data[3]
            }   
        })
        getVideos(page).then(res=>{
            if(res.code === 200){
                this.url = res.data['energy_factory'].url
                this.cover = res.data['energy_factory'].thumbnail
            }
        }).catch(err=>{
            this.$message.error(err.message)   
        })
    }
}
</script>

<style scoped lang="less">
// .oo{
//     background-image: url('../../assets/image/资源 74.png');
//     height: 2000px;
// }
.pain{
    .pain_container{
        padding: 5rem 0;
        // height: 800px;
        width: 100%;
        background-color: #171717;
        .pain_item{
            width: 80%;
            height: 60%;
            margin: 0 auto;
            display: flex;
            justify-content: space-between;
            .item_container{
                width: 20%;
                padding: 2rem 0;
                border-radius: 0.5rem;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                background-color: #303030;
                .line{
                    width: 16%;
                    margin: 15%;
                    border-bottom: 2px solid #54d1ef;
                }
            }
        }
    }
}
.resolve{
    .resolve_container{
        background-color: #000;
        padding: 5rem 0;
    }
}
.video{
    .video_container{
        background-color: #1e1d1d;
        padding: 5rem 0;
    }
}
</style>